import { TableField } from '@models/ui/table-model';
import { CustomizableFields } from '@models/ui/table-model';
import { IntroConfig } from '@models/common/IntroConfig';
import { DocumentStatusEnum } from './Enum/DocumentStatusEnum';
import { AppLink, AppLinkLocation } from './app-link-model';

export const uiVersion = 2;

export const routerLink: AppLink[] = [
  {
    title: 'home',
    viewName: 'approvalProcess',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/home',
    classes: 'hidden',
  },
  {
    title: 'titleProcessArchive',
    viewName: 'documents',
    classes: 'tb-intro-doc_archive',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/document',
  },
  {
    title: 'documentArchive',
    viewName: 'documentArchive',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/document-archive',
  },
  {
    title: 'fulfillment',
    viewName: 'fulfillment',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/fulfillment',
  },
  {
    title: 'titleRegistries',
    viewName: 'registries',
    classes: 'tb-intro-registry',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/registries',
  },
  {
    title: 'taskInfo',
    viewName: 'taskInfo',
    location: AppLinkLocation.SIDEBAR,
    regex: /^\/pages\/tasks\/info\/.*/,
  },
  {
    title: 'assertion',
    viewName: 'settings',
    location: AppLinkLocation.SIDEBAR,
    regex: /^\/pages\/assertion\/confirm\/.*/,
  },
  {
    title: 'titleDepartments',
    viewName: 'departmentView',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/department-management',
  },
  {
    title: 'titleDepartments',
    viewName: 'departmentView',
    location: AppLinkLocation.SIDEBAR,
    regex: /^\/pages\/department-management(?:\/([a-zA-Z0-9_ -%]+))?$/,
  },
  /*
  {
    title: 'wallet',
    viewName: 'wallet',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/ssi/wallet',
  },
  */
  {
    title: 'notification',
    viewName: 'notification',
    location: AppLinkLocation.USERMENU,
    link: '/pages/notification',
  },
  {
    title: 'profile',
    viewName: 'profile',
    location: AppLinkLocation.USERMENU,
    link: '/pages/profile',
  },
  {
    title: 'payment',
    viewName: 'payment',
    location: AppLinkLocation.USERMENU,
    link: '/upgrade/pay',
  },
  {
    title: 'EIDAS',
    viewName: 'eidas',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/eidas',
  },
  {
    title: 'homeFAQ',
    viewName: 'helpCenter',
    goToUrl: 'https://support.joinyourbit.com',
    location: AppLinkLocation.SIDEBAR,
  },
  {
    title: 'administrativeDashboard',
    viewName: 'administrativeDashboard',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/administrative-dashboard',
  },
  {
    title: 'analyticDashboard',
    viewName: 'analyticDashboard',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/analytic-dashboard',
  },
  {
    title: 'workflow',
    viewName: 'workflow',
    location: AppLinkLocation.SIDEBAR,
    link: '/pages/wf',
    classes: 'hidden',
  },
];


export const introjsPageElements: Record<string, IntroConfig[]> = {
  '/pages/home': [
    { name: 'tb-intro-doc_archive', position: 'right' },
    { name: 'tb-intro-registry', position: 'right' },
    { name: 'tb-intro-latest_prorcess', position: 'top' },
    { name: 'tb-intro-home_sign', position: 'bottom' },
    { name: 'tb-intro-home_upload', position: 'bottom' },
    { name: 'tb-intro-home_dataprocess', position: 'bottom' },
    { name: 'tb-intro-notification', position: 'bottom' },
    { name: 'tb-intro-user_dropdown', position: 'bottom' },
  ],
  '/pages/document': [
    { name: 'tb-intro-doc_archive_page', position: 'top' },
    { name: 'tb-intro-advanced_search', position: 'bottom' },
  ],

  '/pages/tasks/info': [
    { name: 'tb-intro-sign_status', position: 'bottom' },
    { name: 'tb-intro-sign_refuse', position: 'top' },
    {
      name: 'tb-intro-sign_download',
      position: 'top',
      mobileName: 'tb-intro-sign_download_mobile',
    },
    { name: 'tb-intro-sign_confirm', position: 'top' },
  ],
  '/pages/wf': [
    { name: 'mat-horizontal-stepper-header-container', position: 'bottom' },
    { name: 'tb-intro-process_attachments', position: 'top' },
    { name: 'tb-intro-process_metadata', position: 'top' },
    { name: 'tb-intro-process_protocolNumberAuto', position: 'top' },
    { name: 'tb-intro-process_verify', position: 'top' },
    { name: 'tb-intro-signers_choose', position: 'bottom' },
    { name: 'tb-intro-signers_share', position: 'top' },
    { name: 'tb-intro-signers_draft', position: 'top' },
  ],
  /*
  '/pages/wf/0': [
  ],
  '/pages/wf/1': [
  ],
  '/pages/wf/2': [
  ]
  */
};


export const dummyDocName = '$data$mode$';

// subType cartella fiscale
export const taxFile = 'taxFile';
export const Scadenzario = 'Scadenzario';


export const processTableColumns: CustomizableFields = {
  configName: 'processTableColumns',
  allFields: [
    new TableField('name', 'processName'),
    new TableField('subject', 'docNumber'),
    new TableField('subtype', 'documentType'),
    new TableField('processId', 'idTask'),
    new TableField('taskId', 'idTaskPs'), //taksId for physical security processes
    new TableField('creationDate', 'creationDate', 'date', 'dd MMM yyyy - HH:mm zzzz'),
    new TableField('documentSpecType', 'documentSpecType'),
    new TableField('physicalSecuritySubject', 'subject'),
    new TableField('departmentName', 'departments'),
    new TableField('contractCounterpart', 'contractCounterpart'),
  ],
  defaultFields: ['name', 'subject', 'subtype', 'documentSpecType', 'processId', 'creationDate'],
};

export const docArchiveTableColumns: CustomizableFields = {
  configName: 'docArchiveTableColumns',
  allFields: [
    {name: 'name', label: 'fileName', sortable: true} as TableField,
    {name: 'processId', label: 'idTask', maxWidth: '100px', sortable: true} as TableField,
    {name: 'documentObject', label: 'docNumber', sortable: true} as TableField,
    {name: 'creationDate', label: 'creationDate', pipe: 'date', format: 'dd MMM yyyy - HH:mm zzzz', maxWidth: '230px', sortable: true} as TableField,
    {name: 'subtype', label: 'documentType', sortable: false} as TableField,
    {name: 'documentSpecType', label: 'documentSpecType', sortable: false} as TableField,
    {name: 'departmentName', label: 'departments', sortable: false} as TableField,
    {name: 'contractCounterpart', label: 'contractCounterpart', sortable: false} as TableField,
  ],
  defaultFields: ['name', 'processId', 'documentObject', 'creationDate'],
};
